import Image from 'next/image';
import React from 'react';
import { images } from '../../../Constants/ImageUrls';
import BabiesCounter from './BabiesCounter';
import {
  CounterSection,
  GetToKnow,
  JoyBundleSection,
  MyloBabyTrustContainer,
  TrustPointers,
} from './styled';
import { mylobabyTrustData } from './common';

function PdpTrustSection(props) {
  return (
    <MyloBabyTrustContainer>
      <div className="ImageContainer">
        <Image
          loading="lazy"
          quality={90}
          src={images.pdpTrust}
          alt=""
          fill
          sizes="100vw"
        />
      </div>
      <JoyBundleSection>
        <div className="myloImageContainer">
          <Image
            loading="lazy"
            quality={90}
            src={images.myloBaby}
            alt=""
            fill
            sizes="100vw"
          />
        </div>
        <div className="textSection">
          <p className="title">JOY FOR YOUR BUNDLE OF JOY</p>
          <p className="subTitle">
            Science-backed, gentle and effective personal care and hygiene
            solutions to raise a happy baby
          </p>
        </div>
      </JoyBundleSection>
      <CounterSection>
        <GetToKnow>
          <p className="shape">Get to know Mylo</p>
        </GetToKnow>
        {/* <div className="skewClass"></div> */}
        <TrustPointers>
          {mylobabyTrustData?.map((element, index) => {
            return (
              <div className="pointers" key={`data_${index}`}>
                <Image width="24" height="24" src={element?.image} alt="" />
                <p>{element?.text}</p>
              </div>
            );
          })}
        </TrustPointers>
        <BabiesCounter />
      </CounterSection>
    </MyloBabyTrustContainer>
  );
}

export default PdpTrustSection;
